import Model, { attr } from '@ember-data/model';
import { cached } from '@glimmer/tracking';

export default class AirbnbOfficialReviewModel extends Model {
  @attr('date') checkIn!: Date;
  @attr('date') checkOut!: Date;
  @attr('string') bookingId!: string;
  @attr('string') guestName!: string;
  @attr('string') listingName!: string;
  @attr('string') listingId!: string;
  @attr('string') country!: string;
  @attr('string') city!: string;
  @attr('number') overallRating!: number;
  @attr('number') cleanlinessRating!: number;
  @attr('number') accuracyRating!: number;
  @attr('number') communicationRating!: number;
  @attr('number') checkinRating!: number;
  @attr('number') locationRating!: number;
  @attr('number') valueRating!: number;
  @attr('array', { defaultValue: () => [] })
  positiveReviewTags!: string[];
  @attr('array', { defaultValue: () => [] })
  negativeReviewTags!: string[];
  @attr('string') guestPublicReview!: string;
  @attr('string') hostPublicReview!: string;

  @cached
  get hasTripIssues(): boolean {
    const negativeTags = this.negativeReviewTags ?? [];
    return negativeTags.length > 0;
  }
}

declare module 'ember-data/types/registries/model' {
  interface ModelRegistry {
    'airbnb-official-review': AirbnbOfficialReviewModel;
  }
}
